"use client";

import ColorPicker from './ColorPicker';
export default ColorPicker;